import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { Fade } from "@progress/kendo-react-animation";
import { Button } from "@progress/kendo-react-buttons";
import { SvgIcon } from "@progress/kendo-react-common";
import { DropDownList } from "@progress/kendo-react-dropdowns"
import { Switch, TextBox, TextBoxChangeEvent, TextBoxProps } from "@progress/kendo-react-inputs";
import { useLocalization } from "@progress/kendo-react-intl";
import { Avatar } from "@progress/kendo-react-layout";
import { NotificationGroup, Notification } from "@progress/kendo-react-notification";
import { plusIcon, saveIcon, trashIcon } from "@progress/kendo-svg-icons";
import axios from "axios";
import { useCallback, useEffect, useRef, useState } from "react";
import { AccessToken } from "../../../config/AccessToken";
import { loadingPanel } from "../../LoadingPanel";

export const ConfigRulesAlarmActionHandlers = () => {

    const localizationService = useLocalization();
    let languageId = localStorage.getItem('languageId');
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [instance, accessTokenRequest] = AccessToken();

    const [actionHandlerName, setActionHandlerName] = useState<TextBoxProps["value"]>('');
    const [actionHandlerIdSelected, setActionHandlerIdSelected] = useState(-1);
    const [actionHandlerSelected, setActionHandlerSelected] = useState<any>('');

    const [typeIdSelected, setTypeIdSelected] = useState<any>([]);
    const [typeNameSelected, setTypeNameSelected] = useState<any>([]);
    const [alarmMac, setAlarmMac] = useState<TextBoxProps["value"]>('');
    const [alarmIp, setAlarmIp] = useState<TextBoxProps["value"]>('');

    const [alarmCurrentValue, setAlarmCurrentValue] = useState<any>([]);

    const [newActionHandler, setNewActionHandler] = useState<any>([]);

    const [channelSelected, setChannelSelected] = useState<any>();
    const [channelValue, setChannelValue] = useState<any>();
    const [saved, setSaved] = useState(false);
    const [updated, setUpdated] = useState(false);
    const [removed, setRemoved] = useState(false);
    const [nameMessage, setNameMessage] = useState(false);

    const [loading, setLoading] = useState(false);

    const [checked, setChecked] = useState(true);

    const userType = localStorage.getItem('userType');


    const handleToggleSwitch = (event: any) => {
        //console.log(event.target.value);
        setChecked(event.target.value);
    };

    const types = {
        data: [
            {
                "id": 0,
                "name": "Traffic light"
            }
        ]
    };

    const channels = {
        "data": [
            { "id": 0, "name": 'Channels 0' },
            { "id": 1, "name": 'Channels 1' },
            { "id": 2, "name": 'Channels 2' },
            { "id": 3, "name": 'Channels 3' }
        ]
    }

    useEffect(() => {
        getActionHandlerList();
    }, []);

    const getActionHandlerList = async () => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/subscription/actionhandler/list`, { headers })
                .then((res) => {
                    const data = res.data.data
                    if (data.length > 0) {
                        setNewActionHandler(data)
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false);
                });
        }
        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const loadSelectedAlarmActionHandler = (alarm: any) => {

        setActionHandlerIdSelected(alarm.id)

        setActionHandlerName(alarm.name);
        setAlarmMac(alarm.mac);
        setAlarmIp(alarm.ipAddress);
        setActionHandlerSelected(alarm);

        let typeIdSelected: any = '';
        let typeSelected: any = '';
        types.data.map((type: any) => {
            if (type.id == alarm.type) {
                typeIdSelected = type.id
                typeSelected = type.name
            }
        })
        setTypeIdSelected(typeIdSelected)
        setTypeNameSelected(typeSelected);

        // Access the clicked element's ref
        itemRefs?.current?.forEach((element: any, i: any) => {
            if (i == alarm.id) {
                itemRefs.current[i].style.background = '#198792';
                itemRefs.current[i].style.borderRadius = '10px';
                itemRefs.current[i].style.color = '#ffffff';
            } else {
                itemRefs?.current[i]?.style?.removeProperty('background')
                itemRefs?.current[i]?.style?.removeProperty('color')
            }
        });

    }

    const handleChangeAlarmActionName = useCallback((event: TextBoxChangeEvent) => {
        setActionHandlerName(event.target.value);
        setAlarmCurrentValue([...alarmCurrentValue, event.target.value]);
        //setNewAlarmActionHandler([...newAlarmActionHandler, event.target.value]);
    }, [])

    const onTypesChange = (event: any) => {
        setTypeNameSelected(event.value)

        let typeIdSelected: any = '';
        types.data.map((type: any) => {
            if (type.name == event.value) {
                typeIdSelected = type.id
            }
        })
        setTypeIdSelected(typeIdSelected)
    }

    const onChannelChange = (event: any) => {
        setChannelSelected(true)
        setChannelValue(event.value)
        //setCurrentValue([...currentValue, event.target.value]);        
        //setNewSubscription([...newSubscription, event.target.value]);
    }

    const handleChangeAlarmActionMac = useCallback((event: TextBoxChangeEvent) => {
        setAlarmMac(event.target.value);
    }, []);

    const sanitizeIpInput = (value: string): string => {
        if (!value) return '';

        // solo caratteri validi
        let cleaned = value.replace(/[^0-9.]/g, '');

        // evita doppi punti
        cleaned = cleaned.replace(/\.{2,}/g, '.');

        // max 3 punti
        const parts = cleaned.split('.');
        return parts.slice(0, 4).join('.');
    };

    const isIpComplete = (value: string): boolean => {
        return /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/.test(value.trim());
    };

    const isIpInvalid = alarmIp !== '' && !isIpComplete(String(alarmIp));

    const handleChangeAlarmActionIp = useCallback((event: TextBoxChangeEvent) => {
        const rawValue = event.target.value ?? '';
        const sanitizedValue = sanitizeIpInput(String(rawValue));
        setAlarmIp(sanitizedValue);
    }, []);

    const handleTestLight = (alarmActionName: any) => {
        console.log(alarmActionName);
    }

    const updateActionHandlerSelected = async (idSelected: any) => {

        if (isIpInvalid) {
            return;
        }

        setLoading(true);

        const params = {
            type: typeIdSelected,
            mac: alarmMac,
            name: actionHandlerName,
            ipAddress: alarmIp
        }

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            try {
                await axios.put(`${SERVER_URL}/Subscription/ActionHandler/${idSelected}`, params, { headers })

                setNewActionHandler([...newActionHandler, actionHandlerName]);

                setLoading(false);

                getActionHandlerList();

                setUpdated(true)
                if (!updated) {
                    setTimeout(() => {
                        setUpdated(false);
                    }, 3000);
                }

            } catch (error: any) {
                //setError(error?.message);
                setLoading(false);
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }



    }

    const saveNewActionHandler = async (alarmActionName: any) => {

        setLoading(true);

        if (isIpInvalid) {
            setLoading(false);
            return;
        }

        if (alarmActionName.length == 0) {
            setNameMessage(true)
        } else {
            setNewActionHandler([...newActionHandler, alarmActionName]);
            setActionHandlerName('');
            setAlarmMac('');
            setAlarmIp('');
            setAlarmCurrentValue([]);

            const params = {
                'ipAddress': alarmIp,
                'name': alarmActionName,
                'mac': alarmMac,
                'type': typeIdSelected
            };

            const commonOperations = (accessToken: any) => {
                const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
                axios.post(`${SERVER_URL}/subscription/actionhandler`, params, { headers })
                    .then(() => {

                        setSaved(true)

                        getActionHandlerList();

                        setLoading(false);

                        setTimeout(() => {
                            setSaved(false)
                        }, 3000);

                    }).catch((data) => {
                        setLoading(false);
                        //setError(data?.message);
                    });
            }

            if (localStorage.getItem('accessToken') != null) {
                let accessToken = localStorage.getItem('accessToken');
                commonOperations(accessToken);
            } else {
                await instance.initialize();
                await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                    // Acquire token silent success
                    let accessToken = accessTokenResponse.accessToken;
                    commonOperations(accessToken);
                })
                    .catch((error: any) => {
                        if (error instanceof InteractionRequiredAuthError) {
                            instance.acquireTokenRedirect(accessTokenRequest);
                        }
                        console.log(error);
                    });
            }
        }

        if (saved) {
            setTimeout(() => {
                setSaved(false);
            }, 3000);
        }
        if (nameMessage) {
            setTimeout(() => {
                setNameMessage(false);
            }, 3000);
        }
    }

    const removeAlarmActionHandler = async (alarm: any, index: any) => {

        setLoading(true);

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.delete(`${SERVER_URL}/subscription/actionhandler/${alarm.id}`, { headers })
                .then(() => {
                    setNewActionHandler((oldValues: any) => {
                        return oldValues.filter((_: any, i: any) => i !== index)
                    })

                    setLoading(false);
                    setRemoved(true);
                    if (!removed) {
                        setTimeout(() => {
                            setRemoved(false);
                        }, 3000);
                    }
                }).catch((data) => {
                    setLoading(false);
                });
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const itemRefs: any = useRef([]);


    return (
        <div className="flex-parent-element">
            {loading ? loadingPanel : null}

            <br />
            <NotificationGroup
                style={{
                    right: 0,
                    bottom: 50,
                    alignItems: "flex-start",
                    flexWrap: "wrap-reverse",
                }}
            >
                <Fade enter={true} exit={true}>
                    {saved && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            closable={true}
                            onClose={() => setSaved(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.alarm_action_handler_saved', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {updated && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            closable={true}
                            onClose={() => setUpdated(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.alarm_action_handler_updated', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {nameMessage && (
                        <Notification
                            type={{ style: "warning", icon: true }}
                            closable={true}
                            onClose={() => setNameMessage(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.alarm_action_handler_name_message', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {removed && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            closable={true}
                            onClose={() => setRemoved(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.alarm_action_handler_removed', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {/*{commandMessage && (
                        <Notification
                            type={{ style: "warning", icon: true }}
                            closable={true}
                            onClose={() => setCommandMessage(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_command_type_message', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {actuatorMessage && (
                        <Notification
                            type={{ style: "warning", icon: true }}
                            closable={true}
                            onClose={() => setActuatorMessage(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_actuator_message', 'NOT FOUND')}</span>
                        </Notification>
                    )}*/}
                    {/*{created && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            closable={true}
                            onClose={() => setCreated(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.timeslot_updated', 'NOT FOUND')}</span>
                        </Notification>
                    )}*/}
                </Fade>
            </NotificationGroup>

            {/*left panel*/}
            <div
                style={{
                    padding: '20px',
                    background: "#F7F7F7",
                    flex: '1 1 300px',
                    overflowY: 'auto'
                }}
            >
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                    <p
                        style={{ display: 'inline-flex', textAlign: 'center', fontSize: '20px', color: '#1A8893' }}
                    >
                        {localizationService.toLanguageString('configuration.rules.alarm_action_handler', 'NOT FOUND')} ({newActionHandler.length})
                    </p>
                    <Button
                        title={localizationService.toLanguageString('configuration.rules.alarm_action_handler_addNew', 'NOT FOUND')}
                        themeColor={"primary"}
                        className="plusParam"
                        style={{
                            marginRight: '10px',
                            marginTop: '0px',
                        }}
                        disabled={userType === 'UserAdminOnlyLocator' || userType === 'StandardOnlyLocator'}
                        onClick={() => {
                            let resetActionHandler = -1
                            setActionHandlerIdSelected(resetActionHandler);
                            setActionHandlerName('');
                            setTypeNameSelected('')
                            setAlarmMac('')
                            setAlarmIp('')
                            setChannelValue('')
                            //saveNewActionHandler(actionHandlerName)
                        }}
                    >
                        <Avatar
                            className="plusParam"
                        >
                            <SvgIcon
                                icon={plusIcon}
                                style={{ margin: '8px' }}
                            />
                        </Avatar>
                    </Button>
                </div>

                <div>
                    <div
                        style={{
                            marginLeft: '30px'
                        }}
                    >
                        {newActionHandler?.map((alarm: any, index: any) => {
                            return (
                                <div
                                    key={index}
                                    style={{
                                        cursor: `${userType === 'StandardOnlyLocator' || userType === 'UserAdminOnlyLocator' ? 'default' : 'pointer'}`,
                                    }}
                                >
                                    <div
                                        className="trash-icon"
                                        style={{
                                            float: 'left',
                                            cursor: `${userType === 'StandardOnlyLocator' || userType === 'UserAdminOnlyLocator' ? 'default' : 'pointer'}`,
                                            alignContent: 'center',
                                            marginRight: '10px',
                                            pointerEvents: `${userType === 'StandardOnlyLocator' || userType === 'UserAdminOnlyLocator' ? 'none' : 'auto'}`,
                                            opacity: `${userType === 'StandardOnlyLocator' || userType === 'UserAdminOnlyLocator' ? 0.5 : 1}`
                                        }}
                                        title={localizationService.toLanguageString('configuration.rules.subscription_remove', 'NOT FOUND')}
                                        onClick={() => removeAlarmActionHandler(alarm, index)}
                                    >
                                        <Avatar
                                            className="trash-icon"
                                        >
                                            <SvgIcon icon={trashIcon} style={{ verticalAlign: 'baseline', margin: '10px' }} />
                                        </Avatar>
                                    </div>
                                    <p
                                        className="card-block-registry-group"
                                        ref={(el) => (itemRefs.current[alarm.id] = el)}
                                        style={{
                                            cursor: 'pointer',
                                            marginLeft: '10px',
                                            marginBottom: '0px',
                                            padding: '10px'
                                        }}
                                        onClick={() => loadSelectedAlarmActionHandler(alarm)}
                                    >
                                        {alarm.name}
                                    </p>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>

            {/*right panel*/}
            <div
                className="flex-right-child-element"
                style={{
                    background: 'white',
                    flex: '1 1 500px',
                }}
            >
                <div>
                    <div style={{ display: 'flex', marginBottom: '20px' }}>
                        <div style={{ width: '150px', alignContent: 'center' }}>
                            {localizationService.toLanguageString('configuration.rules.alarm_action_handler_name', 'NOT FOUND')}
                        </div>
                        <div style={{ display: 'flex', width: '350px' }}>
                            <TextBox
                                style={{ width: "350px", marginRight: '10px' }}
                                value={actionHandlerName != '' ? actionHandlerName : ''}
                                onChange={handleChangeAlarmActionName}
                                placeholder={localizationService.toLanguageString('configuration.rules.alarm_action_handler_name', 'NOT_FOUND')}
                                disabled={userType === 'StandardOnlyLocator' || userType === 'UserAdminOnlyLocator'}
                            />

                            {actionHandlerIdSelected == -1 ?
                                //save 
                                <Button
                                    title={localizationService.toLanguageString('configuration.rules.alarm_action_handler_save', 'NOT FOUND')}
                                    themeColor={"primary"}
                                    className="saveParam"
                                    disabled={actionHandlerName == '' ? true : false || typeNameSelected.length == 0 ? true : false || isIpInvalid || userType === 'UserAdminOnlyLocator' || userType === 'StandardOnlyLocator'}
                                    onClick={() => saveNewActionHandler(actionHandlerName)}
                                >
                                    <Avatar
                                        className="saveParam"
                                    >
                                        <SvgIcon
                                            icon={saveIcon}
                                            style={{ margin: '8px' }}
                                        />
                                    </Avatar>
                                </Button>
                                :
                                // add & updated 
                                <div style={{ display: 'inline' }} >
                                    <Button
                                        title={localizationService.toLanguageString('configuration.rules.alarm_action_handler_update', 'NOT FOUND')}
                                        themeColor={"primary"}
                                        className="saveParam"
                                        style={{
                                            marginRight: '10px'
                                        }}
                                        disabled={actionHandlerName == '' ? true : false || isIpInvalid || userType === 'UserAdminOnlyLocator' || userType === 'StandardOnlyLocator'}
                                        onClick={() => updateActionHandlerSelected(actionHandlerIdSelected)}
                                    >
                                        <Avatar
                                            className="saveParam"
                                        >
                                            <SvgIcon
                                                icon={saveIcon}
                                                style={{ margin: '8px' }}
                                            />
                                        </Avatar>
                                    </Button>
                                </div>
                            }
                        </div>
                    </div>

                    <div style={{ display: 'flex', marginBottom: '20px' }}>
                        <div style={{ width: '150px', alignContent: 'center' }}>
                            {localizationService.toLanguageString('configuration.rules.alarm_action_handler_type', 'NOT FOUND')}
                        </div>
                        <DropDownList
                            style={{
                                width: "350px",
                            }}
                            data={types.data.map((type: any) => {
                                return type.name
                            })}
                            value={typeNameSelected}
                            onChange={onTypesChange}
                            disabled={userType === 'StandardOnlyLocator' || userType === 'UserAdminOnlyLocator'}
                        />
                    </div>

                    <div style={{ display: 'flex', marginBottom: '20px' }}>
                        <div style={{ width: '150px', alignContent: 'center' }}>
                            {localizationService.toLanguageString('configuration.rules.alarm_action_handler_mac', 'NOT FOUND')}
                        </div>
                        <TextBox
                            style={{ width: "350px" }}
                            value={alarmMac != '' ? alarmMac : ''}
                            onChange={handleChangeAlarmActionMac}
                            placeholder={localizationService.toLanguageString('configuration.rules.alarm_action_handler_mac', 'NOT_FOUND')}
                            disabled={userType === 'StandardOnlyLocator' || userType === 'UserAdminOnlyLocator'}
                        />
                    </div>

                    <div style={{ display: 'flex', marginBottom: '20px' }}>
                        <div style={{ width: '150px', alignContent: 'center' }}>
                            {localizationService.toLanguageString('configuration.rules.alarm_action_handler_ip', 'NOT FOUND')}
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <TextBox
                                style={{ width: "350px" }}
                                value={alarmIp != '' ? alarmIp : ''}
                                onChange={handleChangeAlarmActionIp}
                                placeholder={localizationService.toLanguageString('configuration.rules.alarm_action_handler_ip', 'NOT_FOUND')}
                                disabled={userType === 'StandardOnlyLocator' || userType === 'UserAdminOnlyLocator'}
                            />
                            {alarmIp !== '' && !isIpComplete(String(alarmIp)) && (
                                <span style={{ color: '#B00020', fontSize: '12px', marginTop: '4px' }}>
                                    {localizationService.toLanguageString('configuration.rules.alarm_action_handler_ip_invalid', 'NOT_FOUND')}
                                </span>
                            )}
                        </div>
                    </div>

                    <div style={{ display: 'flex', marginBottom: '20px' }}>
                        <div style={{ width: '150px', alignContent: 'center' }}>
                            {localizationService.toLanguageString('configuration.rules.alarm_action_handler_test_light', 'NOT FOUND')}
                        </div>
                        <div>
                            <div style={{ display: 'flex', width: '350px' }}>
                                <DropDownList
                                    style={{
                                        width: "263px",
                                        marginRight: '20px'
                                    }}
                                    data={channels.data?.map((channel: any) => {
                                        return (
                                            channel.name
                                        )
                                    })}
                                    value={channelValue}
                                    onChange={onChannelChange}
                                    disabled={userType === 'StandardOnlyLocator' || userType === 'UserAdminOnlyLocator'}
                                />

                                <Switch
                                    onChange={handleToggleSwitch}
                                    checked={checked}
                                    disabled={userType === 'StandardOnlyLocator' || userType === 'UserAdminOnlyLocator'}
                                />
                            </div>
                        </div>
                    </div>
                    {/*<label className="k-ml-3">{test}</label>*/}

                    {/*<div
                        title={localizationService.toLanguageString('configuration.rules.alarm_action_handler_test_light', 'NOT FOUND')}
                        className="k-icon k-font-icon k-i-notification"
                        style={{ marginLeft: '20px', zoom: '1.5', cursor: 'pointer' }}
                        onClick={() => handleTestLight(alarmActionName)}
                    >
                    </div>*/}

                </div>
            </div>
        </div>
    )
}